import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/mobile-menu.css';
import { useGeneralData } from "../data/GeneralDataContext";
import { useResponsive } from "../contexts/ResponsiveContext";

const TestMobileMenu = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { evd_general_data } = useGeneralData();
    const { isMobile } = useResponsive();
    
    // Get general data for social links
    const generalData = evd_general_data && evd_general_data.length > 0 ? evd_general_data[0] : null;
    
    // If not mobile, don't render anything
    if (!isMobile) {
        return null;
    }
    
    const menuItems = [
        { text: 'HOME', to: '/' },
        { text: 'GALLERY', to: '/projects' },
        { text: 'ABOUT', to: '/about' },
        { text: 'CONTACT', to: '/contact' }
    ];
    
    return (
        <>
            <button
                onClick={() => setIsOpen(true)}
                style={{
                    position: 'fixed',
                    top: '20px',
                    right: '20px',
                    padding: '10px',
                    background: 'transparent', // Transparent background
                    border: 'none',
                    cursor: 'pointer',
                    zIndex: 10000,
                    fontSize: '24px',
                    color: 'black', // Black color
                }}
            >
                ☰
            </button>

            <div style={{
                position: 'fixed',
                top: 0,
                right: 0,
                width: '280px',
                height: '100vh',
                backgroundColor: '#ffffff',
                zIndex: 10002,
                transform: isOpen ? 'translateX(0)' : 'translateX(280px)',
                transition: 'transform 0.5s ease-in-out',
                boxShadow: '-5px 0 15px rgba(0, 0, 0, 0.1)',
                overflowY: 'auto',
            }}>
                <nav style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                }}>
                    <div style={{
                        textAlign: 'center',
                        marginBottom: '40px',
                        padding: '20px',
                        backgroundColor: '#f8f8f8',
                    }}>
                        <img src="/images/favicon.png" alt="EVD Logo" style={{ maxWidth: '150px', height: 'auto' }} />
                    </div>
                    
                    <ul style={{
                        listStyle: 'none',
                        padding: '0 30px',
                        margin: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-end',
                    }}>
                        {menuItems.map((item, index) => (
                            <li key={index} style={{
                                width: '100%',
                                textAlign: 'right',
                                marginBottom: '15px',
                                position: 'relative',
                            }}>
                                <Link
                                    to={item.to}
                                    style={{
                                        color: '#000000',
                                        textDecoration: 'none',
                                        fontSize: '16px',
                                        fontWeight: 600,
                                        letterSpacing: '2px',
                                        display: 'block',
                                        padding: '15px 0',
                                        borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                                        transition: 'all 0.3s ease',
                                        position: 'relative',
                                    }}
                                    onClick={() => setIsOpen(false)}
                                >
                                    {item.text}
                                </Link>
                            </li>
                        ))}
                    </ul>
                    
                    {generalData && (
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            marginTop: '30px',
                            padding: '0 30px 20px',
                        }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                gap: '15px',
                                marginBottom: '15px',
                            }}>
                                {generalData.instagram_url && (
                                    <a href={generalData.instagram_url} target="_blank" rel="noopener noreferrer" aria-label="Instagram" style={{
                                        color: '#393836',
                                        fontSize: '18px',
                                        transition: 'all 0.3s ease',
                                    }}>
                                        <i className="bi bi-instagram"></i>
                                    </a>
                                )}
                                {generalData.facebook_url && (
                                    <a href={generalData.facebook_url} target="_blank" rel="noopener noreferrer" aria-label="Facebook" style={{
                                        color: '#393836',
                                        fontSize: '18px',
                                        transition: 'all 0.3s ease',
                                    }}>
                                        <i className="bi bi-facebook"></i>
                                    </a>
                                )}
                                {generalData.x_url && (
                                    <a href={generalData.x_url} target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)" style={{
                                        color: '#393836',
                                        fontSize: '18px',
                                        transition: 'all 0.3s ease',
                                    }}>
                                        <i className="bi bi-twitter-x"></i>
                                    </a>
                                )}
                            </div>
                            <div style={{
                                textAlign: 'center',
                                color: '#666666',
                                fontSize: '12px',
                                marginBottom: '10px',
                            }}>
                                © {new Date().getFullYear()} {generalData.evd_copyright || 'EVD Construction'}
                            </div>
                            <Link to="/terms" onClick={() => setIsOpen(false)} style={{
                                color: '#666666',
                                fontSize: '12px',
                                textDecoration: 'none',
                                transition: 'color 0.3s ease',
                            }}>
                                Terms & Conditions
                            </Link>
                        </div>
                    )}
                </nav>
            </div>

            {isOpen && (
                <div
                    onClick={() => setIsOpen(false)}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.3)',
                        zIndex: 10001,
                        transform: 'translateX(-280px)',
                        transition: 'transform 0.3s ease-in-out, opacity 0.3s ease',
                        opacity: 0.8,
                        backdropFilter: 'blur(3px)',
                        WebkitBackdropFilter: 'blur(3px)',
                    }}
                />
            )}
        </>
    );
};

export default TestMobileMenu;
